<template>
  <div>
    <ProductGallery
      class="osk-product-galleries__gallery"
      :product="product"
      @open-dialog="openDialog"
    />

    <ProductGalleryDialog
      v-model="dialogProduct"
      :product="product"
      :current-image="currentImage"
    />
  </div>
</template>

<script setup lang="ts">
import { ProductImageDTO, ProductDTORes } from '~/restAPI/data-contracts';

const props = defineProps<{
  product: ProductDTORes,
}>();

const dialogProduct = ref(false);
const currentImage = ref<ProductImageDTO>();

function openDialog(image: ProductImageDTO) {
  currentImage.value = image;
  dialogProduct.value = true;
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

</style>
